import i18n from 'i18next';
import en from 'app/util/i18n/en';
import { initReactI18next } from 'react-i18next';

const resources = {
	en: {
		translation: en
	}
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		lng: 'en',

		keySeparator: '.', // we do use keys in form messages.welcome

		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;
